import { render, staticRenderFns } from "./PlayerInfoModal.vue?vue&type=template&id=152e63ce&scoped=true&"
import script from "./PlayerInfoModal.vue?vue&type=script&lang=ts&"
export * from "./PlayerInfoModal.vue?vue&type=script&lang=ts&"
import style0 from "./PlayerInfoModal.vue?vue&type=style&index=0&id=152e63ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152e63ce",
  null
  
)

export default component.exports